import { Navigate } from 'react-router-dom';

import authService from '../../utils/services/authService';

const Protected = ({ redirectTo, role, children }) => {
  const userData = authService.getUserData();

  if (userData !== false) {
    if (role.includes(userData.role)) {
      return children;
    } else {
      return <Navigate to={redirectTo} />;
    }
  } else {
    return <Navigate to={redirectTo} />;
  }
};

export default Protected;
